const { __ } = wp.i18n;
import BMediaUpload from "../components/BMediaUpload/BMediaUpload";
const { TabPanel, Panel, PanelBody, PanelRow, Button, __experimentalUnitControl: UnitControl, TextControl } = wp.components;
const { InspectorControls } = wp.blockEditor;

const Settings = (props) => {
  const { attributes, setAttributes } = props;
  const { audios, width } = attributes;

  const handleList = (property, value, index) => {
    const newAudios = [...audios];
    newAudios[index][property] = value;
    setAttributes({ audios: newAudios });
  };

  const tabController = () => {
    setTimeout(() => {
      const panelBodies = document.querySelectorAll(".components-panel__body-title button");
      panelBodies.forEach((item) => {
        item.addEventListener("click", clickEveryItem);
      });

      function clickEveryItem() {
        this.removeEventListener("click", clickEveryItem);
        panelBodies.forEach((item) => {
          if (item.getAttribute("aria-expanded") === "true" && !item.isEqualNode(this)) {
            item.click();
          }
        });
        setTimeout(() => {
          this.addEventListener("click", clickEveryItem);
        }, 500);
      }
    }, 500);
  };

  return (
    <InspectorControls style={{ marginBottom: "40px" }}>
      <TabPanel
        className="bPSS"
        activeClass="active-tab"
        onSelect={tabController}
        tabs={[
          {
            name: "content",
            title: "Content",
            className: "content btTab",
          },
          {
            name: "style",
            title: "Style",
            className: "settings btTab",
          },
        ]}
      >
        {(tab) => {
          return (
            <span>
              {tab.name == "content" && (
                <span>
                  <Panel>
                    <PanelBody>
                      {audios.map(({ source, poster, title, artist }, index) => {
                        return (
                          <PanelBody key={index} title={title || __("No Title", "h5ap")} initialOpen={false}>
                            <BMediaUpload
                              onSelect={(audio) => handleList("source", audio, index)}
                              value={source}
                              type={["audio"]}
                              placeholder={__("Audio Source", "h5ap")}
                              label={__("Audio Source", "h5ap")}
                            />

                            <label></label>
                            <BMediaUpload
                              onSelect={(poster) => handleList("poster", poster, index)}
                              value={poster}
                              type={["image"]}
                              placeholder={__("Thumbnail", "h5ap")}
                              label={__("Thumbnail", "h5ap")}
                            />

                            <PanelRow>
                              <TextControl placeholder={__("Title", "h5ap")} value={title} onChange={(title) => handleList("title", title, index)} />
                            </PanelRow>
                            <PanelRow>
                              <TextControl placeholder={__("Artist", "h5ap")} value={artist} onChange={(artist) => handleList("artist", artist, index)} />
                            </PanelRow>
                            <div className="d-flex">
                              <Button
                                icon="trash"
                                className="trash"
                                onClick={() => {
                                  setAttributes({ audios: audios.filter((item, itemIndex) => index !== itemIndex) });
                                }}
                              ></Button>
                            </div>
                          </PanelBody>
                        );
                      })}
                      <Button
                        onClick={() => {
                          setAttributes({ audios: [...audios, { source: "" }] });
                        }}
                        isPrimary={true}
                      >
                        Add New
                      </Button>
                    </PanelBody>
                  </Panel>
                </span>
              )}
              {tab.name == "style" && (
                <span>
                  <Panel>
                    <PanelBody>
                      <PanelRow>
                        <UnitControl
                          label={__("Width", "h5ap")}
                          labelPosition="side"
                          units={[
                            { value: "px", label: "px", default: 500 },
                            { value: "%", label: "%", default: 100 },
                          ]}
                          onChange={(width) => setAttributes({ width })}
                          value={typeof width === "object" ? `${width.number}${width.unit}` : width}
                          isResetValueOnUnitChange={true}
                        />
                      </PanelRow>
                    </PanelBody>
                  </Panel>
                </span>
              )}
            </span>
          );
        }}
      </TabPanel>
    </InspectorControls>
  );
};

export default Settings;
